import * as z from 'zod';
import { ErrorMessages } from './error-messages';

export const eventTicketInfoFormSchema = z.object({
  ticketTypes: z
    .array(
      z
        .object({
          id: z.string().optional(),
          label: z.string().min(1, ErrorMessages.Required),
          quantity: z.string().min(1, ErrorMessages.Required),
          isFree: z.boolean().optional().default(true),
          price: z.string().optional(),
          type: z.string().optional(),
        })
        .refine(
          ({ isFree, price }) =>
            isFree || Number(price?.replace(/[^\d.]/g, '')),
          {
            message: ErrorMessages.Required,
            path: ['price'],
          },
        ),
    )
    .optional(),
  guestTicketTypes: z
    .array(
      z
        .object({
          id: z.string().optional(),
          label: z.string().min(1, ErrorMessages.Required),
          quantity: z.string().min(1, ErrorMessages.Required),
          isFree: z.boolean().optional().default(true),
          price: z.string().optional(),
          type: z.string().optional(),
        })
        .refine(
          ({ isFree, price }) =>
            isFree || Number(price?.replace(/[^\d.]/g, '')),
          {
            message: ErrorMessages.Required,
            path: ['price'],
          },
        ),
    )
    .optional(),
  timeSlots: z.array(
    z.object({
      id: z.string().optional(),
      time: z
        .string()
        .min(1, ErrorMessages.Required)
        .regex(/(0?\d|1[0-2]):[0-5]\d/, ErrorMessages.Time.INVALID),
      period: z.enum(['AM', 'PM']),
      endTime: z
        .string()
        .min(1, ErrorMessages.Required)
        .regex(/(0?\d|1[0-2]):[0-5]\d/, ErrorMessages.Time.INVALID),
      endTimePeriod: z.enum(['AM', 'PM']),
      quantity: z.string().min(1, ErrorMessages.Required),
    }),
  ),
});

export type EventTicketInfoForm = z.TypeOf<typeof eventTicketInfoFormSchema>;
